<!--
  The icon set. One component, one stroke weight, one geometry.

  Drawn rather than imported: five glyphs do not justify a dependency, and a
  font or sprite sheet would be a second asset to cache-bust. Every icon is a
  24-unit square stroked at 1.6 in `currentColor`, matching the wordmark's
  chrome in TopBar, so an icon inherits the colour of whatever it sits beside
  and needs no theme of its own.

  Icons here are DECORATION. Every one of them sits next to a text label that
  already says the same thing, so they are `aria-hidden` without exception --
  an icon that needs announcing is a control, and a control needs a real name,
  not a picture.
-->
<script lang="ts">
  let {
    name,
    size = '1rem',
  }: {
    name: 'folder' | 'folder-open' | 'trash' | 'documents' | 'chevron'
    size?: string
  } = $props()
</script>

<svg
  class="icon"
  class:icon-chevron={name === 'chevron'}
  style="--icon-size: {size}"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="1.6"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
  focusable="false"
>
  {#if name === 'folder'}
    <path d="M3 6.5A1.5 1.5 0 0 1 4.5 5h4.1a1.5 1.5 0 0 1 1.2.6l1 1.4h7.7A1.5 1.5 0 0 1 20 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-14A1.5 1.5 0 0 1 3 17.5z" />
  {:else if name === 'folder-open'}
    <path d="M3 6.5A1.5 1.5 0 0 1 4.5 5h4.1a1.5 1.5 0 0 1 1.2.6l1 1.4h7.7A1.5 1.5 0 0 1 20 8.5V10" />
    <path d="M3 17.5V10h18.2a.8.8 0 0 1 .77 1l-1.8 6.9a1.5 1.5 0 0 1-1.45 1.1H4.5A1.5 1.5 0 0 1 3 17.5z" />
  {:else if name === 'trash'}
    <path d="M4.5 7h15" />
    <path d="M9.5 7V5.5A1.5 1.5 0 0 1 11 4h2a1.5 1.5 0 0 1 1.5 1.5V7" />
    <path d="M6.5 7l.8 11.1a1.5 1.5 0 0 0 1.5 1.4h6.4a1.5 1.5 0 0 0 1.5-1.4L17.5 7" />
    <path d="M10.5 11v5M13.5 11v5" />
  {:else if name === 'documents'}
    <path d="M7 3.5h6l4 4v11a1.5 1.5 0 0 1-1.5 1.5h-8.5A1.5 1.5 0 0 1 5.5 18.5v-13A1.5 1.5 0 0 1 7 3.5z" />
    <path d="M12.8 3.5V8h4.2" />
    <path d="M8.5 12.5h7M8.5 15.5h4.5" />
  {:else if name === 'chevron'}
    <path d="M9.5 6.5 15 12l-5.5 5.5" />
  {/if}
</svg>

<style>
  .icon {
    width: var(--icon-size);
    height: var(--icon-size);
    flex: 0 0 auto;
    display: block;
  }

  /*
   * The chevron is drawn pointing RIGHT and rotated a quarter turn when open,
   * so collapsed and expanded are one path at two angles rather than two
   * glyphs that can drift apart. The rotation is what the eye follows, so it
   * is animated -- and waived for anyone who asked for less motion.
   */
  .icon-chevron {
    transition: rotate var(--duration-micro, 0.15s) var(--ease-in-out, ease);
  }

  @media (prefers-reduced-motion: reduce) {
    .icon-chevron {
      transition: none;
    }
  }
</style>
